




import Vue from 'vue';
import RateLimiter from '@/common/components/support/RateLimiter.vue';

export default Vue.extend({
  components: {
    RateLimiter,
  },
});
